module.exports = __webpack_public_path__ + "img/head.e1148120.png";